import { useState } from "react";

export interface PaginationProps {
  totalCount: number;
  pageSize: number;
  currentPage: number;
}

export interface PaginationResult {
  pages: number[];
  hasPrevious: boolean;
  hasNext: boolean;
  previous: () => void;
  next: () => void;
  goToPage: (page: number) => void;
}

export const usePagination = ({ totalCount, pageSize, currentPage }: PaginationProps): PaginationResult => {
    const [page, setPage] = useState(currentPage);
  
    const totalPages = Math.ceil(totalCount / pageSize);
  
    const hasPrevious = page > 1;
    const hasNext = page < totalPages;
  
    const previous = () => {
      if (hasPrevious) setPage((prev) => prev - 1);
    };
  
    const next = () => {
      if (hasNext) setPage((prev) => prev + 1);
    };
  
    const goToPage = (pageNumber: number) => {
      if (pageNumber >= 1 && pageNumber <= totalPages) setPage(pageNumber);
    };
  
    // Fixed Pages Calculation
    const pages = Array.from(
      { length: Math.min(5, totalPages) },
      (_, index) => {
        const startPage = Math.max(1, Math.min(page - 2, totalPages - 4));
        return startPage + index;
      }
    );
  
    return { pages, hasPrevious, hasNext, previous, next, goToPage };
  };
  